import styled from "styled-components";
import Button from "components/atoms/Button";

export const Container = styled.div`
  font-family: "Roboto";
  font-size: 1.6rem;
`;

export const ButtonsSection = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: 4rem;
  flex-wrap: wrap;
  width: 50%;
  ${({ fullWidth }) => fullWidth && "width: 100%"}
`;

export const ButtonGroup = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: space-between;
  gap: 4rem;
`;

export const StyledButton = styled(Button)`
  min-width: min-content;
  height: min-content;
  padding: 0 2rem;
  flex: 1;
`;

export const SaveButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 2rem;
`;

export const ToggleRoleButton = styled.div`
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: 400;

  &:hover {
    color: ${({ theme }) => theme.colors.treePoppy};
  }
`;
